import FormPageTemplate from './FormPageTemplate'

const ArchitectureNewScopePage = () => (
    <FormPageTemplate
        titleKey="admin.monday.new_scope"
        subtitleKey="admin.monday.fill_details_scope"
        defaultFormType="estimados_2026_new_scope"
        returnPath="/architecture"
    />
)

export default ArchitectureNewScopePage
